// extracted by mini-css-extract-plugin
export default {"searchFleet":"Search_searchFleet__wGlR4","title":"Search_title__ZPO6U","container":"Search_container__xaI+z","empty":"Search_empty__SAojv"};